// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zappyride_incentive_web--TabSection-module--gridStyle--kEhrRY0h1zbOVIYg_hJc {
  margin-top: 24px;
}
.zappyride_incentive_web--TabSection-module--gridStyle--kEhrRY0h1zbOVIYg_hJc > div[role=tabpanel] {
  width: 99%;
}
.zappyride_incentive_web--TabSection-module--contentStyle--JGfrYEicTQuUvceXfg_1 {
  padding-top: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/Tabs/TabSection.module.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;AAAI;EACI,UAAA;AAER;AAEA;EACI,iBAAA;AACJ","sourcesContent":[".gridStyle {\n    margin-top: 24px;\n    > div[role='tabpanel'] {\n        width: 99%;\n    }\n}\n\n.contentStyle {\n    padding-top: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gridStyle": `zappyride_incentive_web--TabSection-module--gridStyle--kEhrRY0h1zbOVIYg_hJc`,
	"contentStyle": `zappyride_incentive_web--TabSection-module--contentStyle--JGfrYEicTQuUvceXfg_1`
};
export default ___CSS_LOADER_EXPORT___;
